import { API } from "../../config/api/index";

//ALL TYPE WISE DATA RETURN
const initState = {
  inventoryList: [],
  partsList: [],
  partsBrandList: [],
  partsCategoryList: [],
  tyreModalList: [],

  inventoryPartNumber: [],
  inventoryTyreDimension: [],
  inventoryPartName: [],
  inventoryPartsCategory: [],
  inventoryPartsBrand: [],
  inventoryTyreModel: [],
  inventoryBatchList: [],
  supplierInvoiceAray: [],
};

//DEFINE ACCOUNT REDUCER FUNCTION
const InventoryReducer = (state = initState, action) => {
  switch (action.type) {
    case API.inventory.getList:
      return {
        ...state,
        inventoryList: action.inventoryList,
      };

    case API.inventory.parts.list:
      return {
        ...state,
        partsList: action.partsList,
      };

    case API.inventory.partsBand.list:
      return {
        ...state,
        partsBrandList: action.partsBrandList,
      };

    case API.inventory.partsCategory.list:
      return {
        ...state,
        partsCategoryList: action.partsCategoryList,
      };

    case API.inventory.tyreModal.list:
      return {
        ...state,
        tyreModalList: action.tyreModalList,
      };

    case API.inventory.tableViewList.tyreModel:
      return {
        ...state,
        inventoryTyreModel: action.inventoryTyreModel,
      };

    case API.inventory.tableViewList.partBrand:
      return {
        ...state,
        inventoryPartsBrand: action.inventoryPartsBrand,
      };

    case API.inventory.tableViewList.partCategory:
      return {
        ...state,
        inventoryPartsCategory: action.inventoryPartsCategory,
      };

    case API.inventory.tableViewList.partName:
      return {
        ...state,
        inventoryPartName: action.inventoryPartName,
      };

    case API.inventory.tableViewList.tyreDimension:
      return {
        ...state,
        inventoryTyreDimension: action.inventoryTyreDimension,
      };

    case API.inventory.tableViewList.partNumber:
      return {
        ...state,
        inventoryPartNumber: action.inventoryPartNumber,
      };

    case API.inventory.supplierInvoiceList:
      return {
        ...state,
        supplierInvoiceAray: action.supplierInvoiceAray,
      };
    case API.inventory.getBtachList:
      return {
        ...state,
        inventoryBatchList: action.inventoryBatchList,
      };
    default:
      return state;
  }
};

//EXPORT ALL FUNCTION
export default InventoryReducer;
